import Form from 'epn-ui/umd/dist/components/Form';
import InputText from 'epn-ui/umd/dist/components/InputText';
import Select from 'epn-ui/umd/dist/components/Select';
import DatePicker from 'epn-ui/umd/dist/components/DatePicker';
// import EpnUIConfig from 'epn-ui/umd/dist/components/EpnUIConfig';
import dayjs from 'dayjs';

// Helpers
import useI18n from '@i18n';
import { ISupportCreateMessageFormProps } from '../interface';

// Conponents
import CreateMessageActions from '../TemplateActions';

const SupportOrderForm: React.FC<ISupportCreateMessageFormProps> = ({
    question,
    subject,
    loading,
    onClose,
    onSubmit,
}) => {
    const { t } = useI18n('Support');
    const { t: tCommon } = useI18n('Common');

    return (
        <Form
            name="other"
            onFinish={values => {
                const files = [];

                if (
                    values.files &&
                    Array.isArray(values.files.fileList) &&
                    values.files.fileList.length > 0
                ) {
                    values.files.fileList.forEach(item => {
                        files.push({
                            name: item.name,
                            size: item.size,
                            link: item.response,
                        });
                    });
                }

                const message = `${t('Order number not found')} - «${values.orderNumber}».  \n${t(
                    'Product link label',
                )} - «${values.productLink}».  \n${t('Order device label')} - «${
                    values.purchaseDevice
                }».  \n${t('Order source label')} - «${values.purchaseSource}».  \n${t(
                    'Order date label',
                )} - «${dayjs(values.orderDate).format('DD.MM.YYYY')}».  \n\n ${values.message}`;

                onSubmit({
                    subject: values.subject,
                    message,
                    files,
                });
            }}
            initialValues={{
                message: question,
                subject,
            }}
        >
            <Form.Item
                name="subject"
                rules={[{ required: true, message: tCommon('Required field') }]}
                className="hidden"
            >
                <InputText />
            </Form.Item>

            <Form.Item
                name="orderNumber"
                label={t('Order number label')}
                rules={[{ required: true, whitespace: true, message: tCommon('Required field') }]}
            >
                <InputText />
            </Form.Item>

            <Form.Item
                name="productLink"
                label={t('Product link label')}
                rules={[{ required: true, whitespace: true, message: tCommon('Required field') }]}
            >
                <InputText />
            </Form.Item>

            <Form.Item
                name="purchaseDevice"
                label={t('Order device label')}
                rules={[{ required: true, message: tCommon('Required field') }]}
            >
                <Select
                    options={[
                        {
                            key: 'browser',
                            label: t('Browser'),
                            value: t('Browser'),
                        },
                        {
                            key: 'mobileApp',
                            label: t('Mobile application'),
                            value: t('Mobile application'),
                        },
                    ]}
                    notFoundContent={tCommon('Nothing found')}
                />
            </Form.Item>

            <Form.Item
                name="purchaseSource"
                label={t('Order source label')}
                rules={[{ required: true, message: tCommon('Required field') }]}
            >
                <Select
                    options={[
                        {
                            key: 'web',
                            label: t('Site'),
                            value: t('Site'),
                        },
                        {
                            key: 'plugin',
                            label: t('Browser extension'),
                            value: t('Browser extension'),
                        },
                        {
                            key: 'mobile',
                            label: t('Mobile application'),
                            value: t('Mobile application'),
                        },
                    ]}
                    notFoundContent={tCommon('Nothing found')}
                />
            </Form.Item>

            <Form.Item
                name="orderDate"
                label={t('Order date label')}
                rules={[{ required: true, message: tCommon('Required field') }]}
            >
                <DatePicker className="w-full" format="DD.MM.YYYY" />
            </Form.Item>

            <Form.Item
                name="message"
                rules={[{ required: true, whitespace: true, message: tCommon('Required field') }]}
            >
                <InputText.TextArea
                    placeholder={t('Additional comment')}
                    autoSize={{
                        minRows: 4,
                    }}
                />
            </Form.Item>

            <CreateMessageActions loading={loading} onClose={onClose} />
        </Form>
    );
};

export default SupportOrderForm;
